<template>
    <section class="stepper-a">
        <ul class="nav-steps mt-3" id="stepNew">
            <li v-for="(item, index) in steps" :class="{ 'active': item.active, 'past done': item.done }">
                <a>
                    <span :class="{ 'check-step': !item.done }" class="number-step">✔</span>
                    <span class="number-step" v-if="!item.done">{{ item.position }}</span>
                    <span class="content-step">{{ item.title }}</span>
                </a>
            </li>
        </ul>
    </section>
</template>
<script>

const site = window.__pt.settings.site;
export default {

    props: ['step', 'rapd'],
    data() {
        return {
            data: {},
            steps: [],
            siteConfig: site
        };
    },
    async mounted() {
        this.initialize();
    },
    methods: {
        initialize() {
            let self = this;
            let position = 1;

            self.steps.push({
                position: position,
                title: self.__('messages.enter_your_data'),
                className: "icons-person",
                active: self.step == 1,
                done: self.step > 1
            });

            if (!self.rapd) {
                self.steps.push({
                    position: ++position,
                    title: self.__('messages.method_of_payment'),
                    className: "icons-credit-card-outline",
                    active: self.step == 2,
                    done: self.step > 2
                });
            }

            self.steps.push({
                position: ++position,
                title: self.__('messages.confirmation'),
                className: "icons-check-1",
                active: self.step == 3,
                done: self.step > 3
            });
        }
    },
    components: {
    }
}
</script>
